export const translations = {
  pt: {
    settings: 'Configurações',
    profile: 'Meu Perfil',
    logout: 'Sair da conta',
    language: 'Idioma',
    sensitive: 'Conteúdo Sensível',
    addPrompt: 'Adicionar Prompt',
    sensitiveDescription:
      'Ocultar conteúdos marcados como sensíveis.',
      userId: 'ID do Usuário',
      loginMethod: 'Método de Login',
    // AuthModal translations
    appTitle: 'NEXORA',
    appDescription: 'A maneira inteligente de salvar e explorar prompts',
    continueWithGoogle: 'Continuar com Google',
    or: 'ou',
    emailPlaceholder: 'Seu email',
    passwordPlaceholder: 'Sua senha',
    createAccount: 'Criar conta',
    signIn: 'Entrar',
    alreadyHaveAccount: 'Já possui conta? Entrar',
    dontHaveAccount: 'Não possui conta? Criar conta',
    emailAlreadyInUse: 'Esse email já está cadastrado.',
    // HomePage translations
    searchPrompts: 'Buscar prompts...',
    sensitiveContentHidden: 'Conteúdo HOT está oculto ou borrado até liberar.',
    sensitiveContentVisible: 'Conteúdo HOT é exibido normalmente.',
    hideSensitiveContent: 'Ocultar conteúdo sensível',
    editPrompt: 'Editar Prompt',
    addNewPrompt: 'Adicionar Prompt',
    allCategories: 'Todas as categorias',
    all: 'Todos',
    noPromptsFound: 'Nenhum prompt encontrado',
    addFirstPrompt: 'Adicionar Primeiro Prompt',
    confirmDeletePrompt: 'Tem certeza que deseja deletar este prompt?',
    confirmDeleteCategory: 'Deseja excluir a categoria',
    confirmDeleteCategorySuffix: '? Isso irá mover os prompts para "Sem categoria".',
    errorLoadingData: 'Erro ao carregar dados:',
    errorLoadingPrompts: 'Erro ao carregar prompts:',
    errorLoadingCategories: 'Erro ao carregar categorias:',
    errorDeletingPrompt: 'Erro ao deletar prompt:',
    errorDeletingCategory: 'Erro ao deletar categoria:',
  },

  en: {
    settings: 'Settings',
    profile: 'My Profile',
    logout: 'Logout',
    language: 'Language',
    sensitive: 'Sensitive Content',
    addPrompt: 'Add Prompt',
    sensitiveDescription:
      'Hide content marked as sensitive.',
      userId: 'User ID',
      loginMethod: 'Login Method',
    // AuthModal translations
    appTitle: 'NEXORA',
    appDescription: 'The smart way to save and explore prompts',
    continueWithGoogle: 'Continue with Google',
    or: 'or',
    emailPlaceholder: 'Your email',
    passwordPlaceholder: 'Your password',
    createAccount: 'Create account',
    signIn: 'Sign in',
    alreadyHaveAccount: 'Already have an account? Sign in',
    dontHaveAccount: 'Don\'t have an account? Create account',
    emailAlreadyInUse: 'This email is already registered.',
    // HomePage translations
    searchPrompts: 'Search prompts...',
    sensitiveContentHidden: 'HOT content is hidden or blurred until released.',
    sensitiveContentVisible: 'HOT content is displayed normally.',
    hideSensitiveContent: 'Hide sensitive content',
    editPrompt: 'Edit Prompt',
    addNewPrompt: 'Add Prompt',
    allCategories: 'All categories',
    all: 'All',
    noPromptsFound: 'No prompts found',
    addFirstPrompt: 'Add First Prompt',
    confirmDeletePrompt: 'Are you sure you want to delete this prompt?',
    confirmDeleteCategory: 'Do you want to delete the category',
    confirmDeleteCategorySuffix: '? This will move prompts to "No category".',
    errorLoadingData: 'Error loading data:',
    errorLoadingPrompts: 'Error loading prompts:',
    errorLoadingCategories: 'Error loading categories:',
    errorDeletingPrompt: 'Error deleting prompt:',
    errorDeletingCategory: 'Error deleting category:',
  },

  es: {
    settings: 'Configuración',
    profile: 'Mi Perfil',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    sensitive: 'Contenido Sensible',
    addPrompt: 'Agregar Prompt',
    sensitiveDescription:
      'Ocultar contenido marcado como sensible.',
      userId: 'ID del Usuario',
      loginMethod: 'Método de Inicio',
    // AuthModal translations
    appTitle: 'NEXORA',
    appDescription: 'La forma inteligente de guardar y explorar prompts',
    continueWithGoogle: 'Continuar con Google',
    or: 'o',
    emailPlaceholder: 'Tu email',
    passwordPlaceholder: 'Tu contraseña',
    createAccount: 'Crear cuenta',
    signIn: 'Iniciar sesión',
    alreadyHaveAccount: '¿Ya tienes cuenta? Iniciar sesión',
    dontHaveAccount: '¿No tienes cuenta? Crear cuenta',
    emailAlreadyInUse: 'Este email ya está registrado.',
    // HomePage translations
    searchPrompts: 'Buscar prompts...',
    sensitiveContentHidden: 'El contenido HOT está oculto o borroso hasta liberarlo.',
    sensitiveContentVisible: 'El contenido HOT se muestra normalmente.',
    hideSensitiveContent: 'Ocultar contenido sensible',
    editPrompt: 'Editar Prompt',
    addNewPrompt: 'Agregar Prompt',
    allCategories: 'Todas las categorías',
    all: 'Todos',
    noPromptsFound: 'No se encontraron prompts',
    addFirstPrompt: 'Agregar Primer Prompt',
    confirmDeletePrompt: '¿Estás seguro de que quieres eliminar este prompt?',
    confirmDeleteCategory: '¿Quieres eliminar la categoría',
    confirmDeleteCategorySuffix: '? Esto moverá los prompts a "Sin categoría".',
    errorLoadingData: 'Error al cargar datos:',
    errorLoadingPrompts: 'Error al cargar prompts:',
    errorLoadingCategories: 'Error al cargar categorías:',
    errorDeletingPrompt: 'Error al eliminar prompt:',
    errorDeletingCategory: 'Error al eliminar categoría:',
  },
};